import React from 'react';
import { VStack } from '@chakra-ui/react';

import HeaderMenu from './HeaderMenu/HeaderMenu';
import FreeShippingBanner from './FreeShippingBanner';
import HeaderContent from './HeaderContent/HeaderContent';
import ShoppingBagDrawer from '@/components/cart/ShoppingBagDrawer/ShoppingBagDrawer';

export const FREE_SHIPPING_BANNER_HEIGHT = 36;

const Header = () => {
  return (
    <>
      <ShoppingBagDrawer />
      <VStack backgroundColor="black" gap={0} flexDirection="column" position="relative" width="100%">
        <FreeShippingBanner />
        <HeaderContent />
        <HeaderMenu />
      </VStack>
    </>
  );
};

export default Header;
